import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { IClientCompanyDropdown, ICompanyMastDropdown, IDocumentMastDropdown } from "../../models/IDropdown";
import { Toast } from "primereact/toast";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { AutoComplete } from "primereact/autocomplete";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { LeagleComments } from "./LeagleComments";

interface ILeagalDocument {
    document_ID?: number | null,
    company_ID?: number | null,
    document_Type?: string | null,
    document_Name?: string | null,
    expiration_Date?: Date | null,
}

interface IPaperWork {
    document_ID?: number,
    prime_Vendor_ID?: number,//Client
    document_Name?: string,
    expiration_Date?: Date | string,
    document_Path?: string,
    editedBy?: number,
    editedByName?: string,
    document_Status?: string,
    addedOn?: Date,
    company_ID?: number,

    pO_ID?: number,
    consultant_ID?: number,
}

const schema = yup.object({
    company_ID: yup.number().required("Select Company"),
    // document_Type: yup.string().required("Select Document Type"),
    document_Name: yup.string().required("Select Document Name").min(1, "Select Document Name"),
    expiration_Date: yup.date().nullable().required("Expiration Date is required").typeError("Expiration Date is required")
});

interface IProps {
    vendorCompany: IClientCompanyDropdown,
}

export const PrimeVendorLegalDocument = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [documents, setDocuments] = useState<Array<IDocumentMastDropdown>>();
    const [documentsList, setDocumentsList] = useState<Array<IPaperWork>>([]);
    const [documentFile, setDocumentFile] = useState<File | null | any>(null);
    const [openClauseModal, setOpenClauseModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: any });
    const [activeIndex, setActiveIndex] = useState<number | null>(null);
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [disableDocumentType, setDisableDocumentType] = useState<boolean>(false);
    const toast = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<ILeagalDocument>({
        resolver: yupResolver(schema),
        defaultValues: { document_Type: "Client" },
        shouldFocusError: false
    });

    const onSaveToDB = async (data: any) => {
        setLoading(true);
        let newData: any = { ...data, prime_Vendor_ID: props.vendorCompany.vendor_Company_ID };
        if (newData.document_ID === null || newData.document_ID === undefined || newData.document_ID === 0) {
            delete newData.document_ID;
        };

        let formData = new FormData();
        formData.append("paperwork", JSON.stringify(newData));
        formData.append("file", documentFile);

        const params = {
            method: (data?.document_ID ? "PUT" : "POST"),
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };

        const response = await fetch(`${baseUrl}vwPODetails/addAPWByCompanyID?isFor=${"Client"}`, params);
        if (response.ok) {
            toast.current.show({ severity: 'success', detail: "Uploaded Document Successfully", life: 3000 });
            reset({
                document_ID: null,
                company_ID: null,
                document_Type: null,
                document_Name: null,
                expiration_Date: null,
            });
            setLoading(false);
            setDisableDocumentType(false);
            setDocumentFile(null);
            loadDocumentsList();
        } else {
            setLoading(false);
            if (params.method === "POST") {
                setDocumentFile(null);
            };

            const message = await response.text();
            toast.current.show({ severity: 'error', detail: message, life: 3000 });
        }
    }

    const onSubmit = (data: any) => {
        if (props.vendorCompany !== null && props.vendorCompany !== undefined && props.vendorCompany.vendor_Company_ID !== null && props.vendorCompany.vendor_Company_ID !== undefined && props.vendorCompany.vendor_Company_ID > 0) {
            if (documentFile !== null && documentFile !== undefined) {
                onSaveToDB(data);
            } else toast.current.show({ severity: 'error', content: "Please select a Document File" });
        } else toast.current.show({ severity: 'error', content: "Please select a Vendor Company" });
    };

    const loadDocuments = async (type?: string) => {
        const response = await Fetch("Dropdown/document", "GET", null, null, null);
        if (response) {
            const data: Array<IDocumentMastDropdown> = await response.json();
            const Client: Array<IDocumentMastDropdown> = [];
            data.forEach((d: IDocumentMastDropdown) => {
                if ((d.document_Name.includes("Client MSA"))) Client.push(d);
                if ((d.document_Name.includes("Client Addendum"))) Client.push(d);
            });
            setDocuments(Client);
        }
    }

    const fileUploade = async (event: FileUploadHandlerParam) => {
        if (event.files[0].size > 1024000) {
            event.options.clear();
            toast.current.show({ severity: 'error', content: "Document should be less than 1 MB." });
        } else {
            setDocumentFile(event.files[0]);
            event.options.clear();
            toast.current.show({ severity: 'success', content: "Document Selected." });
        }
    }

    const expiration_Date = (rowData: IPaperWork) => {
        let date;
        if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const downloadDocument = async (data: IPaperWork) => {
        data.pO_ID = data.pO_ID;
        data.consultant_ID = data.consultant_ID;
        data.prime_Vendor_ID = data.prime_Vendor_ID;
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetails/getLegalDocument"}?isFor=${"Client"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.document_Path ? data.document_Path : "document";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const file = (rowData: IPaperWork) => {
        // return <></>;
        return (<span onClick={() => downloadDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };

    const actionBodyTemplate = (rowData: IPaperWork) => {
        return <div style={{ display: 'flex' }}>
            <Button icon="pi pi-pencil" className="p-button-rounded  p-button-text" tooltip="Edit Document" onClick={() => {
                setDocumentFile(null);
                setDisableDocumentType(prev => prev = true);
                setActiveIndex(prev => prev = 0);
                reset({
                    document_ID: rowData.document_ID,
                    company_ID: rowData.company_ID,
                    document_Name: rowData.document_Name,
                    expiration_Date: new Date(rowData.expiration_Date || ""),
                });
            }} />
            <Button icon="pi pi-plus" className="p-button-rounded  p-button-text" tooltip="Add Clause Comment" onClick={() => {
                setOpenClauseModal({ open: true, singleData: rowData });
            }} />

            {/* <Button icon="pi pi-trash" label="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => saveDocument({ ...rowData }, true)} /> */}
        </div>
    };

    const loadDocumentsList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetails/apwByCompanyID", "GET", null, `companyID=${props.vendorCompany.vendor_Company_ID}&isFor=${"Client"}`, toast);
        if (response) {
            const data: Array<IPaperWork> = await response.json();
            setDocumentsList(data);
        }
        setLoading(false);
    }

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    useEffect(() => {
        loadCompany();
        loadDocuments();
    }, []);

    useEffect(() => {
        if (props.vendorCompany !== undefined && props.vendorCompany != null && props.vendorCompany.vendor_Company_ID !== undefined && props.vendorCompany.vendor_Company_ID !== null && props.vendorCompany.vendor_Company_ID > 0) {
            loadDocumentsList();
        }
    }, [props.vendorCompany]);

    return (
        <>
            <Accordion activeIndex={activeIndex}>
                <AccordionTab header="Add Document">
                    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                        <JVDropdown disabled={disableDocumentType} column={3} label="Company Name " control={control} name="company_ID" options={company} optionLabel="company_Name" optionValue="company_ID" error={errors.company_ID?.message} placeholder="Select Company Name" />
                        <JVDropdown disabled={disableDocumentType} required column={3} label="Document Name" control={control} name="document_Name" error={errors.document_Name?.message} options={documents} optionLabel="document_Name" optionValue="document_Name" placeholder="Select Document Name" />
                        <JVDate column={3} label="Expiration Date" minDate={new Date()} required control={control} name="expiration_Date" error={errors.expiration_Date?.message} />
                        <div className="field col-12 md:col-6">
                            <label htmlFor="file">Document<span style={{ color: 'red' }}>*</span></label>
                            <FileUpload chooseLabel="Choose Document" mode="basic" name="file" accept="*" maxFileSize={10000000} auto customUpload uploadHandler={fileUploade} />
                        </div>
                        <div className="field col-12 md:col-6">
                            <label htmlFor="">&nbsp;</label>
                            <div className="w-full flex flex-row-reverse gap-2">
                                <Button style={{ width: "12rem" }} className="p-button-outlined" label="CLEAR" type="button" onClick={() => {
                                    reset({
                                        document_ID: null,
                                        company_ID: null,
                                        document_Type: null,
                                        document_Name: null,
                                        expiration_Date: null,
                                    });
                                    setDisableDocumentType(false);
                                    setDocumentFile(null);
                                }}></Button>
                                <Button loading={loading} style={{ width: "12rem" }} label="SAVE" type="submit"></Button>
                            </div>
                        </div>
                    </form>
                </AccordionTab>
            </Accordion>
            <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={documentsList} header="Client Document List" showGridlines stripedRows loading={tableLoading}
            >
                <Column field="company_Name" header="Company Name" />
                <Column field="document_Name" header="Document Name" />
                <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                <Column field="file" header="File" body={file} />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
                <Column field="document_Status" header="Status" />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '5%' }} />
            </DataTable>
            <LeagleComments open={openClauseModal.open} singleData={openClauseModal.singleData} onClose={() => setOpenClauseModal({ open: false, singleData: {} })} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}